import { Component, OnInit } from '@angular/core';
import { DatabaseService } from '../../Master/database/database.service';
import { RequestdashboardService } from '../../dashboard/requestdashboard/requestdashboard.service';
import { Database } from '../../Master/database/database';
import { DomSanitizer } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { UseraddService } from '../../Master/useradd/useradd.service';
import { FormdashboardService } from '../../dashboard/formdashboard/formdashboard.service';
import { UserService } from '../../Master/user/user.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ArchivedashboardService } from './archivedashboard.service';
import { LocalService } from '../../local.service';
import {encryptdecrypt} from '../../encryptdecrypt';

declare var $: any;

@Component({
  selector: 'app-archivedashboard',
  templateUrl: './archivedashboard.component.html',
  styleUrls: ['./archivedashboard.component.css']
})
export class ArchivedashboardComponent implements OnInit {

  // database details
  dataBases: any = [];
  databaseid: string = '';

  // user details
  conversionuser: number;
  openrequest: number;
  adminuser: number;
  public userid: number;
  _usermappedDatabase = [];
  formStatus: any = [];
  userRole: string = '';
  openForm: any = [];
  // request details
  requestlist: any = [];
  requestlisttmp: any = [];

  // access rights
  sendMenuId: number = 3;
  sendPageName: string = 'Home Dashboard';
  // menu rights
  _actionRights: any;
  submitShow: boolean;
  readOnly: boolean;
  add: boolean;
  edit: boolean;
  delete: boolean;
  // pagination
  p: number = 1;
  searchTextforDatabase: string;
  itemsPerPage: number = 4;
  selectedyear: any = [];
  selecteddatabase: any = [];
  databaseDDSettings = {
    singleSelection: true,
    idField: 'item_id',
    textField: 'item_text',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 7,
    allowSearchFilter: true
  };

  formDDSettings = {
    singleSelection: true,
    idField: 'item_id',
    textField: 'item_text',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 7,
    allowSearchFilter: true
  };
  yearDDSettings = {
    singleSelection: true,
    idField: 'item_id',
    textField: 'item_text',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 7,
    allowSearchFilter: true
};
  yeardata = [];
  databaseList: any = [];
  dbList = [];
  archiveList = [];
  archivedblist = [];
  archivedatabaseList: any = [];
  selectedarchivedatabase: any = [];
  enc=new encryptdecrypt();
  constructor(private databaseService: DatabaseService,
    private toastr: ToastrService,
    private requestdashboardservice: RequestdashboardService,
    private _sanitizer: DomSanitizer,
    private router: Router,
    private useraddService: UseraddService,
    private formdashboardservice: FormdashboardService,
    private userservice: UserService,
    private SpinnerService: NgxSpinnerService,
    private archivedashboardService: ArchivedashboardService,
    private localService: LocalService
  ) { }

  ngOnInit() {
    this.checkIsMenuMapped();
    //this.userid = +localStorage.getItem('userid');
    this.userid = +this.localService.getJsonValue('userid');
    //this.userRole = localStorage.getItem('userrole');
    this.userRole = this.localService.getJsonValue('userrole');
    // this.getUnreadFormDetails();
    // this.getUserMappedDatabase();
    this.getActionRightsList();
    $('.nav.side-menu li').removeClass('active');
    $('.menu_section .side-menu li').removeClass('active');
    this.getDDvalues();
   // this.dashboardList();
  }

  getDDvalues() {


    let yearcondition = { archiveyear: null, archivedbname: null, dbname: null, mode: 'getyear', userid: this.userid };
    let dbcondition = { archiveyear: null, archivedbname: null, dbname: null, mode: 'getdbname', userid: this.userid };
    let archivedbcondition = { archiveyear: null, archivedbname: null, dbname: null, mode: 'getarchivedbname', userid: this.userid };

    Promise.all([this.archivedashboardService.getArchiveDataList(yearcondition).toPromise(),
    this.archivedashboardService.getArchiveDataList(dbcondition).toPromise(),
    this.archivedashboardService.getArchiveDataList(archivedbcondition).toPromise()
    ])
      .then(([yearlist, dblist, archivedblist]) => {
        this.dbList = dblist;
        this.archivedblist = archivedblist;      
        this.yeardata = this.formddvalues(yearlist, 'archiveyear');
        this.databaseList = this.formddvalues(dblist, 'archivedbname');
        this.archivedatabaseList = this.dbddvalues(archivedblist);
        this.getDashboardList();
      });

  }
  getDashboardList() {
    if (this.yeardata.length > 0) {
      let year = [];
      year.push(this.yeardata[0].item_id);
      this.selectedyear = year;
      this.onItemSelect('');
    }
  }


  formddvalues(jsonvalue, key) {
    let data = [];
    let listdata = [];
    if (jsonvalue != null) {
      data = JSON.parse(jsonvalue[0].j);
      data.forEach(element => {

        if (this.selectedyear.join() != '') {
          if (this.selectedarchivedatabase.join() != '') {
            if (element['archiveyear'] == this.selectedyear.join() && element['database'] == this.selectedarchivedatabase.join()) {
              listdata.push({
                item_id: element[key],
                item_text: element[key],
              });
            }
          }
          else {
            if (element['archiveyear'] == this.selectedyear.join()) {
              listdata.push({
                item_id: element[key],
                item_text: element[key],
              });
            }
           
          }

        }       
        else  {
          listdata.push({
            item_id: element[key],
            item_text: element[key],
          });
        }
      });
    }
    if(key == 'archiveyear') {
      listdata = listdata.sort((a, b) => b.item_id - a.item_id);
    }
    return listdata;
  }

  dashboardList() {
    this.SpinnerService.show();
    if (this.selectedyear.join() != '') {
      let details = {
        archiveyear: this.selectedyear.join(),
        archivedbname: this.selecteddatabase.join(),
        dbname: this.selectedarchivedatabase.join(),
        mode: 'getlist',
        userid:this.userid
      };
      this.archivedashboardService.getArchiveDataList(details).subscribe(archivedata => {
        console.log('res: ', archivedata);
        if (archivedata != null) {
          let archivelist = JSON.parse(archivedata[0].j);
          this.archiveList = archivelist == null || archivelist == undefined ? [] : archivelist;




          // this.formdashboardservice.GetUnreadFormCount(this.userid, this.selecteddatabase.join()).subscribe(formstatus => {
          //   if (formstatus != undefined && formstatus.length != 0) {
          //     this.formStatus = formstatus;
          //     console.log('this.formStatus: ', this.formStatus);
          //   }
          // });


          // tslint:disable-next-line: max-line-length
          if (this.selecteddatabase.join() != '') {

            if (this.archiveList.length > 0) {
              Promise.all([this.databaseService.getActive().toPromise(), this.formdashboardservice.GetUnreadFormCount(this.userid, this.selecteddatabase.join() + '_archive_' + this.selectedyear.join()).toPromise()])
                .then(([databasevalue, formstatus]) => {
                  if (formstatus != undefined && formstatus != null) {
                    this.formStatus = formstatus;
                    console.log('this.formStatus: ', this.formStatus);
                    this.archiveList.forEach(element => {
                      let unreadcountdetails = this.formStatus;//.filter(x => x.formconfigname == element.archivedbname && x.dbid == element.dbid);
                      if (unreadcountdetails.length > 0) {
                        let count = 0;
                        unreadcountdetails.forEach(countelement => {
                          count += countelement.unreadcount;
                        });
                        element['unreadcount'] = count;
                      } else {
                        element['unreadcount'] = 0;
                      }
                    });
                  }
                  var allData = [];
                  this.dataBases = [];
                  allData = databasevalue;
                  allData.forEach(item => {
                    let archive = this.archiveList.filter(x => x.dbid == item.databaseid);
                    if (archive.length > 0) {
                      this.dataBases.push({
                        databaseid: item.databaseid,
                        database: item.database,
                        iconclass: item.iconclass,
                        databasedescription: item.databasedescription,
                        databaseiconpath: item.databaseiconpath,
                        status: item.status,
                        createdby: item.createdby,
                        createdon: item.createdon,
                        modifiedby: item.modifiedby,
                        modifiedon: item.modifiedon,
                        active: item.active,
                        databaseicon: item.databaseicon,
                        openrequest: 0,
                        archiveList: archive
                      });
                    }
                  });
                  this.dataBases.sort(function (a, b) { return a.sequenceno - b.sequenceno; });
                  this.SpinnerService.hide();
                }
                , err => {
                  this.dataBases = [];
                  this.SpinnerService.hide();
                  this.toastr.error('Error while getting the archive database data ');
                });
            }
            else {
              this.dataBases = [];
              this.SpinnerService.hide();
              this.toastr.error('No archive data found');
            }
          }
          else {

            Promise.all([this.databaseService.getActive().toPromise()])
              .then(([databasevalue]) => {
                
                var allData = [];
                this.dataBases = [];
                allData = databasevalue;
                allData.forEach(item => {
                  let archive = this.archiveList.filter(x => x.dbid == item.databaseid);
                  if (archive.length > 0) {
                    this.dataBases.push({
                      databaseid: item.databaseid,
                      database: item.database,
                      iconclass: item.iconclass,
                      databasedescription: item.databasedescription,
                      databaseiconpath: item.databaseiconpath,
                      status: item.status,
                      createdby: item.createdby,
                      createdon: item.createdon,
                      modifiedby: item.modifiedby,
                      modifiedon: item.modifiedon,
                      active: item.active,
                      databaseicon: item.databaseicon,
                      openrequest: 0,
                      archiveList: archive
                    });
                  }
                });
                this.dataBases.sort(function (a, b) { return a.sequenceno - b.sequenceno; });
                this.SpinnerService.hide();
              }, err => {
                this.dataBases = [];
                this.SpinnerService.hide();
                this.toastr.error('Error while getting the archive database data ');
              });

           

          }



          // this.databaseService.getActive().toPromise().then(databasevalue => {
          //   var allData = [];
          //   this.dataBases = [];
          //   allData = databasevalue;
          //   allData.forEach(item => {
          //     let archive = this.archiveList.filter(x => x.dbid == item.databaseid);
          //       if (archive.length > 0) {
          //         this.dataBases.push({
          //           databaseid: item.databaseid,
          //           database: item.database,
          //           iconclass: item.iconclass,
          //           databasedescription: item.databasedescription,
          //           databaseiconpath: item.databaseiconpath,
          //           status: item.status,
          //           createdby: item.createdby,
          //           createdon: item.createdon,
          //           modifiedby: item.modifiedby,
          //           modifiedon: item.modifiedon,
          //           active: item.active,
          //           databaseicon: item.databaseicon,
          //           openrequest: 0,
          //           archiveList: archive
          //         });
          //       }
          //   });
          //   this.dataBases.sort(function (a, b) { return a.sequenceno - b.sequenceno; });
          //   this.SpinnerService.hide();
          // }, err => {
          //   this.SpinnerService.hide();
          //   this.toastr.error('Error while getting the database data ');
          // });
        }
      }, err => {
        this.SpinnerService.hide();
        this.toastr.error('Error while loading the archive data');
      });
    }
    else {
      this.SpinnerService.hide()
      this.toastr.error('Select archive year');

    }
  }


  onItemSelect(event) {
    this.archivedatabaseList = this.dbddvalues(this.archivedblist);
    this.databaseList = this.formddvalues(this.dbList, 'archivedbname');   
    this.dashboardList();
  }

  checkIsMenuMapped()
  {
    const arrays = this.localService.getJsonValue("menulist");
    
    let data = arrays.find(ob => ob['name'] === 'Archive Dashboard');
    if(data == undefined || data =='')
    {
      this.toastr.error('You are not authorized to access this page.');
      this.router.navigate(["home"]);
    }
  }

  getActionRightsList() {
    this.userservice.Get().subscribe(res => {
      let allUser: any = [];
      allUser = res.find(y => y.userid == this.userid);
      var data = JSON.parse(allUser.menumapped);
      if (data != null && data != undefined && data.length != 0) {
        data = data.filter(e => e.menuid == 38);
        if (data != null && data != undefined && data.length != 0) {
          this._actionRights = data[0].action;
        } else {
          this._actionRights = [];
        }

      }
      
      var btnToEnable = this._actionRights;
      if (btnToEnable.length > 0) {
        btnToEnable.forEach(d => {
          if (d != undefined) {
            if (d == 1) {
              this.readOnly = true;
            } else if (d == 2) {
              this.readOnly = true;
              this.add = true;
              this.submitShow = true;
            } else if (d == 3) {
              this.readOnly = true;
              this.edit = true;
              // this.submitShow = true;
            } else if (d == 4) {
              this.readOnly = true;
              this.delete = true;
            }
          }
        });
      }
    });

  }

  formDashboardUnread(item) {
    // this.router.navigate(['/home/formdashboard', { 'db': item.dbid, 'formconfigid': item.formconfigid }]);
    this.router.navigate(['/home/formdashboard'], { queryParams: { 
      'db': this.enc.encryptUsingAES256(item.dbid.toString()), 
      'archiveformconfigid': this.enc.encryptUsingAES256(item.formconfigid.toString()), 
      'archiveyear':this.enc.encryptUsingAES256(this.selectedyear.join()) } });
  }

  getUnreadFormDetails() {
    this.SpinnerService.show();
    this.formdashboardservice.GetUnreadFormCount(this.userid, this.selecteddatabase.join()).subscribe(res => {
      if (res != undefined && res.length != 0) {
        this.formStatus = res;
        // console.log(this.formStatus);
        //  this.SpinnerService.hide();
      }

    });
  }

  // database loading user wise
  getUserMappedDatabase() {
    this.SpinnerService.show();
    this.getUnreadFormDetails();
    // user wise database loding
    this.useraddService.GetById(this.userid).toPromise().then(res => {
      var data = []; let db: any = [];
      let dbuser: any = [];
      data = res;
      db = data.find(y => y.userid == this.userid);
      dbuser = data.find(y => y.userid == this.userid);
      //localStorage.setItem('userrole', db.userrole);
      this.localService.setJsonValue('userrole', db.userrole);
      this._usermappedDatabase = JSON.parse(dbuser.databasemapped).databasemapped;
      this.databaseService.getActive().toPromise().then(res => {
        var allData = [];
        allData = res;
        allData.forEach(item => {
          this._usermappedDatabase.forEach(a => {
            if (item.databaseid == a.databaseid) {
              this.dataBases.push({
                databaseid: item.databaseid,
                database: item.database,
                iconclass: item.iconclass,
                databasedescription: item.databasedescription,
                databaseiconpath: item.databaseiconpath,
                status: item.status,
                createdby: item.createdby,
                createdon: item.createdon,
                modifiedby: item.modifiedby,
                modifiedon: item.modifiedon,
                active: item.active,
                databaseicon: item.databaseicon,
                openrequest: 0
              });
            }
          });
        });

        // open request count binding
        this.requestdashboardservice.GetAll().toPromise().then(res => {
          this.requestlist = res;
          this.openrequest = 0;
          this.requestlisttmp = [];
          this.dataBases.forEach(a => {
            this.getopenrequest(a.databaseid, dbuser, this.requestlist);
            a.openrequest = this.openrequest;
          });
        });

        // sorting databases
        // this.dataBases.sort((a, b) => (a.sequenceno > b.sequenceno) ? -1 : 1);
        this.dataBases.sort(function (a, b) { return a.sequenceno - b.sequenceno; });
        this.SpinnerService.hide();

      }, err => {
        this.SpinnerService.hide();
        this.toastr.error('Error while getting the database data ');


      });

      this.SpinnerService.hide();
    }, error => {
      // console.log(error)
    });
  }
  getbuttonenable(databaseid) {
    var s = this.formStatus.filter(x => x.dbid == databaseid);
    if (s.length != 0) {
      return true;
    } else {
      return false;
    }
  }
  // Navigate to form dashboard
  formDashboard(database) {
    // this.router.navigate(['/home/formdashboard', { 'db': database.databaseid }]);
    //let formConfigValue = this.formStatus.filter(x => x.dbid == database.databaseid);
    //if (formConfigValue.length > 0) {
      // this.router.navigate(['/home/formdashboard', { 'db': database.databaseid }]);
     // let e= new encryptdecrypt();
      this.router.navigate(['/home/formdashboard'], { queryParams:
         { 'db':  this.enc.encryptUsingAES256(database.databaseid.toString()),//database.databaseid,
         'archiveformconfigid': this.enc.encryptUsingAES256(0),//0,
         'archiveyear': this.enc.encryptUsingAES256(this.selectedyear.join().toString()),//this.selectedyear.join() 
        } });
   // } else {
     // this.router.navigate(['/home/requestdashboard', { 'db': database.databaseid, 'archiveformconfigid': 0, 'archiveyear': this.selectedyear.join() }]);
   // }

  }

  // Navigate to request dashboard
  requestDashboard(database) {
    let e= new encryptdecrypt();
    this.router.navigate(['/home/requestdashboard', { 'db': e.encryptUsingAES256(database.databaseid.toString()) }]);
  }

  // Navigate to form render
  formRender(database, type) {
    // alert(database);
    var data = database;
    if ((data != undefined) && (data.length != 0)) {
      this.databaseid = data.databaseid + '*' + data.database;
      //let e= new encryptdecrypt();
      if (type == 'documents') {
        this.router.navigate(['/home/formrender'], { queryParams: {
           'db': this.enc.encryptUsingAES256(this.databaseid.toString()),//this.databaseid, 
        'mode': this.enc.encryptUsingAES256('addByDashboard')//'addByDashboard'
       } });
      }
      // this.router.navigate(['/home/formrender', { 'db': this.databaseid }]);

      if (type == 'requests') {
        this.router.navigate(['/home/requestconfig', { 
          'db': this.enc.encryptUsingAES256(database.databaseid.toString())
        }]);
      }


    }
  }

  // Get open request details
  getopenrequest(dbid, currentuserdetails, requestdetails) {
    this.requestlisttmp = [];
    if ((currentuserdetails.requestmapped != null)) {
      {
        var request1 = JSON.parse(currentuserdetails.requestmapped);
        if (request1.requestmapped.length) {
          this.conversionuser = 1;
        }
      }
    } else {
      this.conversionuser = 0;
    }
    if (currentuserdetails.userrole == 'Admin') {
      this.adminuser = 1;
    }
    requestdetails.forEach(data => {
      if (this.conversionuser == 1) {
        var request = JSON.parse(currentuserdetails.requestmapped);
        for (var i = 0; i < request.requestmapped.length; i++) {
          if (data.status != 'Cancelled' && data.status != 'Closed' && data.dbid == dbid && data.requesttypeid == request.requestmapped[i].requesttypeid) {
            this.requestlisttmp.push(data);
          }
        }
      } else if (this.adminuser == 1) {
        if (data.status != 'Cancelled' && data.status != 'Closed' && data.dbid == dbid) {
          this.requestlisttmp.push(data);
        }
      } else {
        if (data.status != 'Cancelled' && data.status != 'Closed' && data.dbid == dbid && data.createdby == currentuserdetails.userid) {
          this.requestlisttmp.push(data);
        }
      }
    });
    this.openrequest = this.requestlisttmp.length;
  }
  dbddvalues(json) {
    let data = [];
    let listdata = [];
    if (json != null) {
      data = JSON.parse(json[0].j);
      data.forEach(element => {
        if (this.selectedyear.join() != '') {
          if (element['archiveyear'] == this.selectedyear.join()) {
            if (this.selecteddatabase.join() != '') {

              var dbdata = JSON.parse(this.dbList[0].j);
              var seldatabase = '';
              dbdata.forEach(dbelement => {
                if (dbelement['archivedbname'] == this.selecteddatabase.join())
                  seldatabase = dbelement['database'];

              });
             
              if (element['database'] == seldatabase)
              {
                   listdata.push({
                   item_id: element['database'],
                    item_text: element['database'],
                    });
               }
            }
            else {
              listdata.push({
                item_id: element['database'],
                item_text: element['database'],
              });
            }
            
          }
         

        }
        else {

          listdata.push({
            item_id: element['database'],
            item_text: element['database'],
          });
        }


      });
    }
    return listdata;
  }
}
